export class HeatingDeficiencyLayout {
	public fields = [
		{ fieldName: 'heatingDeficiencyIndicator', label: 'Indicator' },
		{ fieldName: 'deficiencyType', label: 'Type' },
		{ fieldName: 'heatingDeficiencySeverity', label: 'Severity' },
		{ fieldName: 'descriptionheatingDeficiency', label: 'Description' }
	];
}
